import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-circle",
  "use": "check-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" stroke=\"inherit\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-check-circle\" id=\"check-circle\">\n  <path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\" fill=\"inherit\" />\n  <polyline points=\"22 4 12 14.01 9 11.01\" stroke=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol